module.exports = __webpack_public_path__ + "img/appeal_indicator.5b44cf75.svg";